var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnerThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 6.72233C29.333 5.25011 30.5219 4.05566 31.9997 4.05566C47.7108 4.05566 60.4441 16.789 60.4441 32.5001C60.4441 37.6779 59.0552 42.5446 56.633 46.7223C55.8997 48.0001 54.2663 48.4334 52.9886 47.7001C51.7219 46.9668 51.2775 45.3334 52.0219 44.0557C53.9886 40.6557 55.1108 36.7112 55.1108 32.4001C55.1108 19.7334 44.7663 9.289 31.9997 9.289C30.5219 9.289 29.333 8.19455 29.333 6.62233V6.72233Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerThird);
export default __webpack_public_path__ + "static/media/spinner-third.406bb739695c723578e7073f4af1b244.svg";
export { ForwardRef as ReactComponent };